export const PasswordInputQa = {
    revealButton: 'reveal-button',
    copyButton: 'copy-button',
};
